// @ts-nocheck
import React, {FunctionComponent, useEffect, useState} from "react";
import {Button} from "../atoms/Button/Button";
import styles from "./StickyFooter.module.scss";
import clsx from "clsx";
import JSONContent from "./content";
import {fireGA} from "../../hooks/tagging";
import {useWindowSize} from "../../hooks/use-window-size";

const StickyFooter: FunctionComponent<{ version?: string; focus: string, variant: string }> = ({version, focus, variant}) => {
    const testVersion = styles.testB;
    const testStyle = "white";

    const [loaded, setLoaded] = useState(false);
    const windowSize = useWindowSize();
    let isMobileDevice = true;
    const device = window.navigator.userAgent.toLowerCase();

    const dataLang = process.env.REACT_APP_LANG === 'spanish' ? 'es' : 'en';

    if (device.indexOf('iphone') === -1 && device.indexOf('ipad') === -1 && device.indexOf('android') === -1) {
        isMobileDevice = false;
    }

    let checkForZoom = () => {

        let stickyFooter = document.querySelectorAll<HTMLElement>("#stickyFooter")[0];

        if (!isMobileDevice) {

            if (window.outerWidth / window.innerWidth >= 2) {
                stickyFooter.style.display = "none";
            }
            else {
                stickyFooter.style.display = "block";
            }
        }
    }

    useEffect(() => {

        const isMobile = windowSize.width < 768;

        if (!loaded) {
            // Remove sticky footer at 200% zoom
            window.addEventListener("resize", function () {
                checkForZoom();
            });
            checkForZoom();

            if (isMobile) {
                if (window.innerWidth <= 430) {
                    document.querySelector<HTMLElement>(`#footer`).style.paddingBottom = "200px";
                }
                else {
                    document.querySelector<HTMLElement>(`#footer`).style.paddingBottom = "180px";
                }
            }
            setLoaded(true);

        }
        else {
        }


    }, [loaded]);


    let btnURL = '';

    if (process.env.REACT_APP_LANG === 'spanish') {
        // atumanera
        // alertas
        // ahorros
        // gasto
        console.log(focus)    
        switch (focus) {
            case "":
                btnURL = "https://accountoffers.wellsfargo.com/checkingoffer/?sub_channel=DS3&vendor_code=WF&collateral_code=csbbespsite&msc=logic";
                break;
            case "creditscore":
                btnURL = "https://accountoffers.wellsfargo.com/checkingoffer/?sub_channel=DS3&vendor_code=WF&collateral_code=csbbespsite&msc=alert";
                break;
            case btnURL = "savings":
                btnURL = "https://accountoffers.wellsfargo.com/checkingoffer/?sub_channel=DS3&vendor_code=WF&collateral_code=csbbespsite&msc=save";
                break;
            case btnURL = "spending":
                btnURL = "https://accountoffers.wellsfargo.com/checkingoffer/?sub_channel=DS3&vendor_code=WF&collateral_code=csbbespsite&msc=spend";
                break;
            default:
                btnURL = "https://accountoffers.wellsfargo.com/checkingoffer/?sub_channel=DS3&vendor_code=WF&collateral_code=csbbespsite&msc=logic";
                break;
        }
    }
    else {
        switch (focus) {
            case "":
                btnURL = "https://accountoffers.wellsfargo.com/checkingoffer/?sub_channel=DS3&vendor_code=WF&collateral_code=csbbsite&msc=eg";
                break;
            case "subscriptions":
                btnURL = "https://accountoffers.wellsfargo.com/checkingoffer/?sub_channel=DS3&vendor_code=WF&collateral_code=csbbsite&msc=subs";
                break;
            case "spending":
                btnURL = "https://accountoffers.wellsfargo.com/checkingoffer/?sub_channel=DS3&vendor_code=WF&collateral_code=csbbsite&msc=spend";
                break;
            case btnURL = "insights":
                btnURL = "https://accountoffers.wellsfargo.com/checkingoffer/?sub_channel=DS3&vendor_code=WF&collateral_code=csbbsite&msc=insights";
                break;
            case btnURL = "savings":
                btnURL = "https://accountoffers.wellsfargo.com/checkingoffer/?sub_channel=DS3&vendor_code=WF&collateral_code=csbbsite&msc=save";
                break;
            case btnURL = "startsmart":
                btnURL = "https://accountoffers.wellsfargo.com/starterbonus/?sub_channel=DS3&vendor_code=WF&collateral_code=csbbsite&msc=cab";
                break;
            case "cardonoff":
                btnURL = "https://accountoffers.wellsfargo.com/checkingoffer/?sub_channel=DS3&vendor_code=WF&collateral_code=csbbsite&msc=card";
                break;
            default:
                btnURL = "https://accountoffers.wellsfargo.com/checkingoffer/?sub_channel=DS3&vendor_code=WF&collateral_code=csbbsite&msc=eg";
                break;
        }
    }

    return (
        <section id="stickyFooter" className={clsx(styles.container, testVersion, "no-parallax")}>
            <div className={styles.content} lang={dataLang}>
                <div className={styles.copy}>
                {(variant === '' || variant === 'a') &&
                    <>
                        <h3>
                            {process.env.REACT_APP_LANG === 'spanish' ? "Obtén una bonificación de $325" : <>Give your money a {version === 'default' ? '$325' : '$125'}&nbsp;bonus</>}
                        </h3>
                        <p>
                            {
                                process.env.REACT_APP_LANG === 'spanish'
                                    ? 'al abrir una nueva cuenta de cheques. Se aplican términos.'
                                    : version === 'default' ? 'when you open a new checking account. Terms apply.' : 'when you open a Clear Access Banking account. Terms apply.'

                            }
                        </p>
                    </>
                }

                {(variant === 'b') &&
                    <>
                        <h3>
                            Join the millions who trust Wells Fargo
                        </h3>
                        <p>
                            and earn a $325 new checking bonus. Terms apply.
                        </p>
                    </>
                }



            
                </div>
                <div className={styles.callToAction}>
                    {process.env.REACT_APP_LANG === 'spanish' && JSONContent.spanish[testStyle].copy &&
						<p>{JSONContent.spanish[testStyle].copy}</p>
                    }
                    {process.env.REACT_APP_LANG !== 'spanish' && JSONContent.english[testStyle].copy &&
						<p>{JSONContent.english[testStyle].copy}</p>
                    }
                    <Button
                        color={testStyle}
                        data-location={"nonwhite background"}
                        size="large"
                        alt={process.env.REACT_APP_LANG === 'spanish' ? JSONContent.spanish[testStyle].alt : 'Get started' + ' - opens in a new browser window'}
                        label={process.env.REACT_APP_LANG === 'spanish' ? JSONContent.spanish[testStyle].cta : `Get started`}
                        // openInNewTab={true}
                        // sectionTagFire={(e as any).currentTarget}
                        destination={btnURL}
                        // tagFire="C1"
                        className={clsx(styles.CTAButton)}
                        lang={process.env.REACT_APP_LANG === 'spanish' ? 'es' : 'en'}
                        onKeyDown={(e) => {
                            const externalLinks = document.querySelectorAll('#externalLinks a');
                            const lastFooterLink = document.querySelectorAll('#externalLinks a')[externalLinks.length - 1] as HTMLElement;
                            if (e.key === "Tab") {
                                e.preventDefault();
                                if (e.shiftKey) {
                                    lastFooterLink!.focus();
                                }
                                else {
                                    document.querySelector<HTMLElement>(`nav > div > a`)!.focus();
                                }
                            }
                        }}
                        onKeyUp={(e) => {
                            e.preventDefault();
                        }}
                        onClick={(e) => {
                            fireGA("C6", (e as any).currentTarget);// maybe good
                            window.open(btnURL);
                        }}
                    />
                </div>

            </div>
        </section>
    );
};

export default StickyFooter;
